





































/* eslint-disable no-mixed-spaces-and-tabs */
import {
	ApplicationUserModel,
	ExchangeRateModel,
	ExchangeRateTypeEnum,
	PartyProductModel,
	QueryOperator,
	WalletModel
} from '@/libs/Api';
import {Guid} from '@/libs/common/functions/guid';
import {Component, Prop, Ref} from 'vue-property-decorator';
import CltDialog from '@/libs/clients/components/CltDialog.vue';
import {applicationUserStore} from '@/libs/user-settings/+state/store';
import {CrudGetter} from '@/libs/core/crud/crud-getter';
import {Constants} from '@/libs/constants/constants';
import {CrudAction, CrudResponseAction} from '@/libs/core/crud/crud-action';
import {createCrudQueryPayload} from '@/libs/core/crud/crud-query';
import {exchangeRatesStore} from '@/libs/exchange-rates/+state/store';
import {walletsStore} from '@/libs/wallets/+state/store';
import Page from "@/Page.vue";

@Component({
    components: {
		CltDialog
    }
})
export default class CLTCard extends Page {

    @Prop() partyProduct!: PartyProductModel;
    @Prop() clientId!: string;
    @Ref() dialog!: CltDialog;
    @Prop({ default: false }) accountSection!: boolean;
    
    wallets: WalletModel[] = [];
    newId: string | null = Guid.EmptyGuid();

    get user(): ApplicationUserModel {
        return applicationUserStore.useGetter(CrudGetter.Detail);
    }

    get walletCZK(): WalletModel {
        return this.wallets.firstOrDefault(x => x.currencyId == Constants.CurrencyCzkId);
    }

    get currentInvestmentValue () {
		const exchangeRateCLT = (exchangeRatesStore.useGetter(CrudGetter.Data, 'LastCLTExchangeRate') as ExchangeRateModel[]).firstOrDefault();
        const exchangeRateUSD = (exchangeRatesStore.useGetter(CrudGetter.Data, 'LastUSDExchangeRate') as ExchangeRateModel[]).firstOrDefault();
        const walletCLT = this.wallets.firstOrDefault(x => x.currencyId == Constants.CurrencyCltId);
		if (exchangeRateUSD != null && exchangeRateCLT != null && walletCLT != null) {
	        return walletCLT.currentValue * exchangeRateUSD.rate * exchangeRateCLT.rate;
        }
        return null;
    }

    mounted() {
        if (this.partyProduct.id != this.newId) {
            this.loadWallets();
            this.loadLastExchangeRates();
        }
    }

    openPartyProduct() {
        this.dialog.open();
    }

    loadWallets () {
        walletsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload(undefined, [
            { field: "partyProductId", op: "eq", comparand: this.partyProduct.id }
        ], undefined, false, 'CltWallets'));
		this.subscribe(walletsStore, CrudAction.GetAll, 'CltWallets').then((wallets: WalletModel[]) => {
			this.wallets = wallets;
		});
    }

    loadLastExchangeRates() {
	    exchangeRatesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ExchangeRateModel>([
		    { field: 'toDate', index: 1, order: 'desc' }
	    ], [
		    { field: 'fromCurrencyId', op: QueryOperator.Eq, comparand: Constants.CurrencyUsdId },
		    { field: 'toCurrencyId', op: QueryOperator.Eq, comparand: Constants.CurrencyCzkId },
		    { field: 'type', op: QueryOperator.Eq, comparand: ExchangeRateTypeEnum.Currency },
		    { field: 'isPublic', op: QueryOperator.Eq, comparand: true }
	    ], { pageIndex: 1, pageSize: 1 }, false, "LastUSDExchangeRate"));
	    exchangeRatesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<ExchangeRateModel>([
		    { field: 'toDate', index: 1, order: 'desc' }
	    ], [
		    { field: 'productId', op: QueryOperator.Eq, comparand: Constants.CltProductId },
		    { field: 'type', op: QueryOperator.Eq, comparand: ExchangeRateTypeEnum.Product },
		    { field: 'isPublic', op: QueryOperator.Eq, comparand: true }
	    ], { pageIndex: 1, pageSize: 1 }, false, "LastCLTExchangeRate"));
    }

}

